import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { ACCOUNT_CLIENT_MODULE, CLIENT_COLUMN } from "../constants/accountSettingsConstants";

export const setClientPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: ACCOUNT_CLIENT_MODULE,
        default_columns: CLIENT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
